import { render, staticRenderFns } from "./OrgLikesTrack.vue?vue&type=template&id=45527d60&scoped=true"
import script from "./OrgLikesTrack.vue?vue&type=script&lang=js"
export * from "./OrgLikesTrack.vue?vue&type=script&lang=js"
import style0 from "./OrgLikesTrack.vue?vue&type=style&index=0&id=45527d60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45527d60",
  null
  
)

export default component.exports